<template>
    <div class="container reporte-ori-container">
        <b-row>
            <b-container>
                <h3 class="text-center py-2">
                    <b><i>REPORTES ORI</i></b>
                </h3>

                <h5 class="text-center py-2">
                    <!-- FILTROS -->
                    <b-row class="mb-4 justify-content-center align-items-end text-lg">
                        <b-col md="auto" class="text-center px-3">
                            <label class="filtro-label">Reporte:</label>
                            <select v-model="selReporte" class="form-control form-control-lg w-auto mx-auto fs-5"
                                style="min-width: 200px;">
                                <option value="">Seleccione...</option>
                                <option v-for="reporte in listReporte" :key="reporte.id" :value="reporte.codigo">
                                    {{ reporte.nombre }}
                                </option>
                            </select>
                        </b-col>

                        <b-col md="auto" class="text-center px-3">
                            <label class="filtro-label">
                                Vigencia:
                            </label>
                            <select v-model="selVigencia" class="form-control form-control-lg w-auto mx-auto fs-5"
                                style="min-width: 200px;">
                                <option value="">Seleccione...</option>
                                <option v-for="vigencia in listVigencia" :key="vigencia.vigencia">
                                    {{ vigencia.vigencia }}
                                </option>
                            </select>
                        </b-col>

                        <b-col md="auto" class="text-center px-3">
                            <label class="filtro-label">
                                Grupo:
                            </label>
                            <select v-model="grupoId" @change="f_filterCompany"
                                class="form-control form-control-lg w-auto mx-auto fs-5" style="min-width: 200px;">
                                <option value="">Todos los grupos</option>
                                <option v-for="grupo in listGrupos" :key="grupo.id" :value="grupo.id">
                                    {{ grupo.nombre }}
                                </option>
                            </select>
                        </b-col>

                        <b-col md="auto" class="text-center px-3">
                            <label class="filtro-label">
                                Compañía:
                            </label>
                            <select v-model="companyId" class="form-control form-control-lg w-auto mx-auto fs-5"
                                style="min-width: 180px; max-width: 250px;">
                                <option value="">Seleccione...</option>
                                <option v-for="company in filteredCompany" :key="company.id" :value="company.id">
                                    {{ company.acronym + " - " + company.nombre }}
                                </option>
                            </select>
                        </b-col>
                    </b-row>

                    <!-- CHECKBOXES -->
                    <b-row class="mb-4 justify-content-center align-items-center">
                        <b-col md="auto" class="text-center px-3" v-if="isReporteVisible">
                            <input type="checkbox" id="Reporte" v-model="mostrarReporte" class="mr-1">
                            <label for="Reporte" class="checkbox-label">Reporte</label>
                        </b-col>

                        <b-col md="auto" class="text-center px-3" v-if="isInformacionVisible">
                            <input type="checkbox" id="Informacion" v-model="mostrarInformacion" class="mr-1">
                            <label for="Informacion" class="checkbox-label">Valor Manual</label>
                        </b-col>

                        <b-col md="auto" class="text-center px-3" v-if="isAjusteConsolVisible">
                            <input type="checkbox" id="AjusteConsol" v-model="mostrarAjusteConsol" class="mr-1">
                            <label for="AjusteConsol" class="checkbox-label">Ajuste Consol</label>
                        </b-col>

                        <b-col md="auto" class="text-center px-3" v-if="isAjusteCombinadoVisible">
                            <input type="checkbox" id="AjusteCombinado" v-model="mostrarAjusteCombinado" class="mr-1">
                            <label for="AjusteCombinado" class="checkbox-label">Ajuste Combinado</label>
                        </b-col>
                        <b-col md="auto" class="text-center px-3" v-if="isConsolidadoVisible">
                            <input type="checkbox" id="Consolidado" v-model="mostrarConsolidado"
                                @change="handleConsolidadoChange" class="mr-1">
                            <label for="Consolidado" class="checkbox-label">Consolidado</label>
                        </b-col>

                        <b-col md="auto" class="text-center px-3" v-if="mostrarConsolidado && isEmpresasVisible">
                            <input type="checkbox" id="Empresas" v-model="mostrarEmpresas"
                                @change="handleEmpresasChange" class="mr-1">
                            <label for="Empresas" class="checkbox-label">Empresas</label>
                        </b-col>
                    </b-row>

                    <!-- BOTÓN -->
                    <b-row class="mb-4 justify-content-center align-items-center">
                        <b-col md="auto" class="text-center">
                            <b-button variant="primary" @click="consultarDatos" class="btn-lg px-5 mx-2 fs-5">
                                <b><i>Generar</i></b>
                            </b-button>
                        </b-col>
                    </b-row>

                    <!-- EMPRESAS CONSOLIDADO -->
                    <b-row v-if="mostrarConsolidado && mostrarEmpresas" class="mt-4">
                        <b-col md="12">
                            <div class="consolidation-section p-4 border rounded bg-light">
                                <label class="d-block fw-bold fs-5 mb-3 text-center">
                                    <b>Empresas para consolidar:</b>
                                </label>

                                <div class="mb-3 text-center">
                                    <b-form-checkbox v-model="selectAllCompanies" @change="toggleAllCompanies"
                                        class="fw-bold fs-6">
                                        {{ selectAllCompanies
                                            ? 'Deseleccionar todas'
                                            : 'Seleccionar todas' }}
                                    </b-form-checkbox>
                                </div>

                                <div class="companies-checkbox-list"
                                    style="max-height: 300px; overflow-y: auto; border: 1px solid #ccc; padding: 15px; border-radius: 5px; background-color: white;">
                                    <b-form-checkbox-group v-model="empresasSeleccionadas" stacked
                                        class="checkbox-group">
                                        <b-form-checkbox v-for="company in listEmpresasDisponibles" :key="company.id"
                                            :value="company.id" class="company-checkbox">
                                            {{ company.acronym ? company.acronym + ' - ' : '' }}{{ company.nombre }}
                                        </b-form-checkbox>
                                    </b-form-checkbox-group>
                                </div>

                                <div class="text-center mt-3">
                                    <b-button variant="outline-secondary" @click="mostrarEmpresas = false"
                                        class="btn-sm">
                                        Ocultar selección
                                    </b-button>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </h5>
            </b-container>
        </b-row>

        <!-- LOADING -->
        <b-row>
            <b-container v-if="isLoading" class="pb-5" style="min-height: 400px;">
                <div class="text-center py-5">
                    <b-spinner variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
                    <h4 class="text-primary mt-3">
                        <b><i>Cargando información...</i></b>
                    </h4>
                </div>
            </b-container>

            <!-- INFORMACIÓN - Tabla de Valores Manuales -->
            <b-container v-if="!isLoading && datosConsultados && (mostrarInformacion || mostrarAjusteConsol || mostrarAjusteCombinado) && listFilasManuales.length > 0"
                class="pb-5">
                <md-table v-model="listFilasManuales" md-card md-fixed-header class="balance-table principal-table">
                    <md-table-toolbar>
                        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                            <div style="flex: 1; text-align: center;">
                                <h1 v-if="mostrarInformacion" class="md-title">
                                    <b><i>Valores Manuales - Valores a Ingresar</i></b>
                                </h1>
                                <h1 v-if="mostrarAjusteConsol" class="md-title">
                                    <b><i>Ajustes de Consolidacion - Valores a Ingresar</i></b>
                                </h1>
                                <h1 v-if="mostrarAjusteCombinado" class="md-title">
                                    <b><i>Ajuste Combinado - Valores a Ingresar</i></b>
                                </h1>
                            </div>
                        </div>
                    </md-table-toolbar>

                    <md-table-row slot="md-table-row" slot-scope="{ item }" @click="abrirModalValor(item)"
                        style="cursor: pointer;">
                        <md-table-cell md-label="Descripción" class="text-left descripcion-cell">
                            {{ item.descripcion || '-' }}
                        </md-table-cell>
                        <md-table-cell md-label="Valor" class="text-right number-cell">
                            {{
                                item.valorGuardado !== null &&
                                    item.valorGuardado !== undefined
                                    ? formatCurrency(item.valorGuardado)
                                    : '0'
                            }}
                        </md-table-cell>
                        <md-table-cell md-label="Funcional" class="text-right number-cell">
                            {{
                                item.funcional1Guardado !== null &&
                                    item.funcional1Guardado !== undefined
                                    ? formatCurrency(item.funcional1Guardado)
                                    : '0'
                            }}
                        </md-table-cell>
                    </md-table-row>
                </md-table>
            </b-container>

            <!-- BALANCE -->
            <b-container v-if="!isLoading && datosConsultados && mostrarBalance && listReportesGuardados.length > 0 && tieneDatosValidos()" class="pb-5">
                <md-table v-model="listReportesGuardados" md-card md-fixed-header class="balance-table principal-table">
                    <md-table-toolbar>
                        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                            <div style="flex: 1; text-align: center;">
                                <h1 class="md-title">
                                    <b><i>{{ tituloTabla }}</i></b>
                                </h1>
                            </div>
                            <div style="display: flex; align-items: center; gap: 10px;">
                                <md-button v-if="listReportesGuardados.length > 0" @click="exportarExcel"
                                    class="md-fab md-primary">
                                    <md-icon>description</md-icon>
                                </md-button>
                            </div>
                        </div>
                    </md-table-toolbar>

                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                        <md-table-cell md-label="Descripción / NIIF (IFRS)" class="text-left descripcion-cell">
                            {{ item.descripcion || '-' }}
                        </md-table-cell>
                        <md-table-cell md-label="Local" class="text-right number-cell">
                            {{ formatCurrency(item.saldo_local) }}
                        </md-table-cell>
                        <md-table-cell md-label="Funcional" class="text-right number-cell">
                            {{ formatCurrency(item.saldo_funcional) }}
                        </md-table-cell>
                        <md-table-cell md-label="Interna" class="text-right number-cell">
                            {{ formatCurrency(item.saldo_interna) }}
                        </md-table-cell>
                    </md-table-row>
                </md-table>
            </b-container>

            <!-- REPORTE COMPARATIVO -->
            <b-container v-if="!isLoading && datosConsultados && mostrarReporte && listReportesComparativo.length > 0" class="pb-5">
                <md-table v-model="listReportesComparativo" md-card md-fixed-header class="balance-table principal-table">
                    <md-table-toolbar>
                        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                            <div style="flex: 1; text-align: center;">
                                <h1 class="md-title">
                                    <b><i>{{ tituloTablaReporte }}</i></b>
                                </h1>
                            </div>
                            <div style="display: flex; align-items: center; gap: 10px;">
                                <md-button v-if="listReportesComparativo.length > 0" @click="exportarExcelReporte"
                                    class="md-fab md-primary">
                                    <md-icon>description</md-icon>
                                </md-button>
                            </div>
                        </div>
                    </md-table-toolbar>

                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                        <md-table-cell md-label="Descripción / NIIF (IFRS)" class="text-left descripcion-cell">
                            {{ item.descripcion || '-' }}
                        </md-table-cell>
                        <md-table-cell :md-label="vigenciaActual" class="text-right number-cell">
                            {{ formatCurrency(item.saldo_actual) }}
                        </md-table-cell>
                    </md-table-row>
                </md-table>
            </b-container>

            <!-- CONSOLIDADO -->
            <b-container v-if="!isLoading && datosConsultados && mostrarConsolidado && listConsolidado.length > 0"
                class="pb-5">
                <md-table v-model="listConsolidado" md-card md-fixed-header class="balance-table principal-table">
                    <md-table-toolbar>
                        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                            <div style="flex: 1; text-align: center;">
                                <h1 class="md-title">
                                    <b><i>{{ tituloTablaConsolidado }}</i></b>
                                </h1>
                            </div>
                            <div class="compact-toggle-container">
                                <div class="toggle-label">
                                    {{ vistaConsolidado === 'Combinado' ? 'Combinado' : 'Combinado' }}
                                </div>
                                <label class="compact-switch">
                                    <input type="checkbox" v-model="vistaConsolidadoBool">
                                    <span class="compact-slider"></span>
                                </label>
                                <select v-if="mostrarSelectorMonedaConsolidado" v-model="monedaConsolidadoSeleccion"
                                    @change="onCambioMonedaConsolidado" class="form-control form-control-sm ml-2"
                                    style="min-width: 165px; max-width: 165px;">
                                    <option v-for="option in monedaConsolidadoOptions" :key="option.value"
                                        :value="option.value">
                                        {{ option.text }}
                                    </option>
                                </select>
                            </div>
                            <div style="display: flex; align-items: center; gap: 10px;">
                                <md-button v-if="listConsolidado.length > 0" @click="exportarExcelConsolidado"
                                    class="md-fab md-primary">
                                    <md-icon>description</md-icon>
                                </md-button>
                            </div>
                        </div>
                    </md-table-toolbar>

                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                        <!-- Columna fija: Descripción -->
                        <md-table-cell md-label="Descripción / NIIF (IFRS)" class="text-left descripcion-cell">
                            {{ item.descripcion || '-' }}
                        </md-table-cell>

                        <!-- Columnas dinámicas: por cada empresa: Saldo + Diff Cambio -->
                        <template v-for="col in columnasConsolidado">
                            <md-table-cell :key="'saldo_' + col"
                                :md-label="obtenerNombreColumnaSaldo(col)"
                                class="text-right number-cell">
                                {{ formatCurrency(getValorColumnaConsolidado(item, col)) }}
                            </md-table-cell>
                            <md-table-cell :key="'diff_' + col"
                                :md-label="obtenerNombreColumnaDiffCambio(col)"
                                class="text-right number-cell">
                                {{ formatCurrency(getDiffCambioConsolidado(item, col)) }}
                            </md-table-cell>
                        </template>

                        <!-- Columnas fijas de consolidación -->
                        <md-table-cell md-label="Ajustes" class="text-right number-cell">
                            {{ formatCurrency(getValorConsolidadoResumen(item, 'ajustes')) }}
                        </md-table-cell>
                        <md-table-cell md-label="Consolidado" class="text-right number-cell">
                            {{ formatCurrency(getValorConsolidadoResumen(item, 'total_consolidado')) }}
                        </md-table-cell>
                        <md-table-cell md-label="Consolidado Diferencia Cambio" class="text-right number-cell">
                            {{ formatCurrency(getTotalDiffCambioConsolidado(item)) }}
                        </md-table-cell>
                        <md-table-cell md-label="Combinado" class="text-right number-cell"
                            v-if="vistaConsolidado === 'Combinado'">
                            {{ formatCurrency(getValorConsolidadoResumen(item, 'combinado')) }}
                        </md-table-cell>
                        <md-table-cell md-label="Total Combinado" class="text-right number-cell"
                            v-if="vistaConsolidado === 'Combinado'">
                            {{ formatCurrency(getValorConsolidadoResumen(item, 'total_combinado')) }}
                        </md-table-cell>
                    </md-table-row>
                </md-table>
            </b-container>

            <!-- MENSAJE SIN INFORMACIÓN -->
            <b-container v-if="!isLoading && datosConsultados && !tieneAlgunDatoValido()">
                <b-col md="2" class="mx-auto">
                    <div class="success-svg mb-4" :class="{ active: true }">
                        <img src="../../assets/imgs/file-2.svg" alt="warning" />
                    </div>
                </b-col>
                <b-col md="12" class="justify-content-around">
                    <span id="message">Sin Información</span>
                </b-col>
            </b-container>
        </b-row>

        <!-- MODAL PARA INGRESAR VALOR MANUAL -->
        <md-dialog :md-active.sync="showModalValor" class="valor-dialog">
            <md-dialog-title v-if="mostrarInformacion" class="dialog-header-create">
                Ingresar Valor Manual
            </md-dialog-title>
            <md-dialog-title v-if="mostrarAjusteConsol" class="dialog-header-create">
                Ingresar Ajuste de Consolidacion
            </md-dialog-title>
            <md-dialog-title v-if="mostrarAjusteCombinado" class="dialog-header-create">
                Ingresar Ajuste Combinado
            </md-dialog-title>

            <md-dialog-content>
                <div class="form-container">
                    <div class="form-group">
                        <label class="field-label">Descripción</label>
                        <md-field>
                            <md-input :value="filaSeleccionada ? filaSeleccionada.descripcion : ''" disabled></md-input>
                        </md-field>
                    </div>

                    <div class="form-group">
                        <label class="field-label required">Valor</label>
                        <md-field>
                            <md-input v-model="valorIngresado" type="number" step="0.01" placeholder="Ingrese el valor"
                                @keyup.enter="guardarValorManual">
                            </md-input>
                        </md-field>
                        <label class="field-label required">Funcional</label>
                        <md-field>
                            <md-input v-model="funcional1Ingresado" type="number" step="0.01" placeholder="Ingrese el valor Funcional"
                                @keyup.enter="guardarValorManual">
                            </md-input>
                        </md-field>
                    </div>
                </div>
            </md-dialog-content>

            <md-dialog-actions>
                <md-button class="md-raised" @click="cerrarModalValor">Cancelar</md-button>
                <md-button class="md-raised md-primary" @click="guardarValorManual"
                    :disabled="valorIngresado === null || valorIngresado === '' || funcional1Ingresado === null || funcional1Ingresado === '' || isVigenciaBloqueada ">
                    Guardar
                </md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script>
import Company from "../../services/Company"
import PlanCuentas from "../../services/PlanCuentas"
import TipoReporte from '../../services/TipoReporte';
import Grupo from "../../services/Grupo";
import Balance from "../../services/BalanceNiif";
import Currency from "../../services/Currency";
import BotonesControl from "../../services/BotonesControl";
import * as XLSX from "exceljs";

export default {
    name: "ReporteORI",
    data: () => ({
        selReporte: "",
        selVigencia: "",
        grupoId: "",
        companyId: "",
        listReporte: [],
        listVigencia: [],
        listGrupos: [],
        listCompany: [],
        filteredCompany: [],
        listReportesGuardados: [],
        isLoading: false,
        datosConsultados: false,
        vistaConsolidado: "Normal",
        monedaFuncional: "COP",
        monedaInterna: "USD",
        mostrarBalance: false,
        mostrarReporte: false,
        mostrarInformacion: false,
        mostrarAjusteConsol: false,
        mostrarAjusteCombinado: false,
        listReportesComparativo: [],
        vigenciaActual: '',
        vigenciaAnterior: '',
        listFilasManuales: [],
        listFilasAjustesConsol: [],
        // Modal
        showModalValor: false,
        filaSeleccionada: null,
        valorIngresado: null,
        funcional1Ingresado: null,
        mostrarConsolidado: false,
        mostrarEmpresas: false,
        empresasSeleccionadas: [],
        listEmpresasDisponibles: [],
        selectAllCompanies: false,
        listConsolidado: [],
        columnasConsolidado: [],
        empresasConsolidadoNombres: {},
        empresasConsolidadoNombresDiff: {},
        currency: [],
        monedaConsolidadoSeleccion: 'funcional1',
    }),

    watch: {
        mostrarBalance(newVal) {
            if (newVal) {
                if (this.mostrarReporte) this.mostrarReporte = false;
                if (this.mostrarInformacion) this.mostrarInformacion = false;
                if (this.mostrarAjusteConsol) this.mostrarAjusteConsol = false;
                if (this.mostrarAjusteCombinado) this.mostrarAjusteCombinado = false;
                if (this.mostrarConsolidado) this.mostrarConsolidado = false;
            }
        },
        mostrarReporte(newVal) {
            if (newVal) {
                if (this.mostrarBalance) this.mostrarBalance = false;
                if (this.mostrarInformacion) this.mostrarInformacion = false;
                if (this.mostrarAjusteConsol) this.mostrarAjusteConsol = false;
                if (this.mostrarAjusteCombinado) this.mostrarAjusteCombinado = false;
                if (this.mostrarConsolidado) this.mostrarConsolidado = false;
            }
        },
        mostrarInformacion(newVal) {
            if (newVal) {
                const estabaAjusteConsol = this.mostrarAjusteConsol;
                const estabaAjusteCombinado = this.mostrarAjusteCombinado;
                if (this.mostrarBalance) this.mostrarBalance = false;
                if (this.mostrarReporte) this.mostrarReporte = false;
                if (this.mostrarConsolidado) this.mostrarConsolidado = false;
                if (this.mostrarAjusteConsol) this.mostrarAjusteConsol = false;
                if (this.mostrarAjusteCombinado) this.mostrarAjusteCombinado = false;
                if (estabaAjusteConsol || estabaAjusteCombinado) this.limpiarVistaManual();
            }
        },
        mostrarAjusteConsol(newVal) {
            if (newVal) {
                const estabaInformacion = this.mostrarInformacion;
                const estabaAjusteCombinado = this.mostrarAjusteCombinado;
                if (this.mostrarBalance) this.mostrarBalance = false;
                if (this.mostrarReporte) this.mostrarReporte = false;
                if (this.mostrarConsolidado) this.mostrarConsolidado = false;
                if (this.mostrarInformacion) this.mostrarInformacion = false;
                if (this.mostrarAjusteCombinado) this.mostrarAjusteCombinado = false;
                if (estabaInformacion || estabaAjusteCombinado) this.limpiarVistaManual();
            }
        },
        mostrarAjusteCombinado(newVal) {
            if (newVal) {
                const estabaInformacion = this.mostrarInformacion;
                const estabaAjusteConsol = this.mostrarAjusteConsol;
                if (this.mostrarBalance) this.mostrarBalance = false;
                if (this.mostrarReporte) this.mostrarReporte = false;
                if (this.mostrarConsolidado) this.mostrarConsolidado = false;
                if (this.mostrarInformacion) this.mostrarInformacion = false;
                if (this.mostrarAjusteConsol) this.mostrarAjusteConsol = false;
                if (estabaInformacion || estabaAjusteConsol) this.limpiarVistaManual();
            }
        },
        grupoId() {
            this.filtrarEmpresasPorGrupo();
            this.empresasSeleccionadas = [];
        },
        mostrarConsolidado(newVal) {
            if (newVal) {
                if (this.mostrarBalance) this.mostrarBalance = false;
                if (this.mostrarReporte) this.mostrarReporte = false;
                if (this.mostrarInformacion) this.mostrarInformacion = false;
                if (this.mostrarAjusteConsol) this.mostrarAjusteConsol = false;
                if (this.mostrarAjusteCombinado) this.mostrarAjusteCombinado = false;
                this.filtrarEmpresasPorGrupo();
            } else {
                this.vistaConsolidado = "Normal";
                this.mostrarEmpresas = false;
                this.empresasSeleccionadas = [];
                this.listConsolidado = [];
                this.datosConsultados = false;
                this.selectAllCompanies = false;
            }
        },
        listEmpresasDisponibles: {
            handler(newVal) {
                if (newVal.length === 0) {
                    this.selectAllCompanies = false;
                }
            },
            deep: true
        },
        empresasSeleccionadas: {
            handler(newVal) {
                if (this.listEmpresasDisponibles.length > 0) {
                    this.selectAllCompanies = newVal.length === this.listEmpresasDisponibles.length;
                }
            },
            deep: true
        }

    },

    computed: {
        isConsolidadoVisible() {
            return this.$store.getters.isControlVisible('ReporteORI', 'Consolidado')
        },
        isReporteVisible() {
            return this.$store.getters.isControlVisible('ReporteORI', 'Reporte')
        },
        isInformacionVisible() {
            return this.$store.getters.isControlVisible('ReporteORI', 'Informacion')
        },
        isAjusteConsolVisible() {
            return this.$store.getters.isControlVisible('ReporteORI', 'AjusteConsol')
        },
        isAjusteCombinadoVisible() {
            return this.$store.getters.isControlVisible('ReporteORI', 'AjusteCombinado')
        },
        isEmpresasVisible() {
            return this.$store.getters.isControlVisible('ReporteORI', 'Empresas')
        },
        isSelectorMonedaVisible() {
            return this.$store.getters.isControlVisible('ReporteORI', 'SelectorMoneda')
        },
        isMonedaFuncional1Visible() {
            return this.$store.getters.isControlVisible('ReporteORI', 'MonedaFuncional1')
        },
        isMonedaFuncional2Visible() {
            return this.$store.getters.isControlVisible('ReporteORI', 'MonedaFuncional2')
        },
        monedaConsolidadoOptions() {
            const options = []
            const moneda1 = this.getNombreMonedaConsolidado('funcional1')
            const moneda2 = this.getNombreMonedaConsolidado('funcional2')
            if (this.isMonedaFuncional1Visible) {
                options.push({ value: 'funcional1', text: moneda1 || 'Funcional 1' })
            }

            if (this.isMonedaFuncional2Visible && (moneda2 || this.tieneMonedaM2Consolidado)) {
                options.push({ value: 'funcional2', text: moneda2 || 'Funcional 2' })
            }
            return options
        },
        tieneMonedaM2Consolidado() {
            if (!Array.isArray(this.listConsolidado) || this.listConsolidado.length === 0) return false
            const primerItem = this.listConsolidado[0] || {}
            return Object.keys(primerItem).some((key) => key.endsWith('_m2'))
        },
        mostrarSelectorMonedaConsolidado() {
            return this.mostrarConsolidado && this.monedaConsolidadoOptions.length > 1
        },
        vistaConsolidadoBool: {
            get() {
                return this.vistaConsolidado === "Combinado";
            },
            set(value) {
                this.vistaConsolidado = value ? "Combinado" : "Normal";
            }
        },
        isVigenciaBloqueada() {
            return this.selVigencia ? !this.$store.getters.isPeriodoEnabled(this.selVigencia) : false;
        },
        tituloTabla() {
            return "ESTADOS DE OTROS RESULTADOS INTEGRALES - ORI";
        },
        tituloTablaReporte() {
            if (this.companyId && this.selVigencia) {
                const company = this.listCompany.find(c => c.id == this.companyId);
                const companyName = company ? `${company.acronym} - ${company.nombre}` : this.companyId;
                return `Reporte ORI Comparativo (${companyName}) ${this.vigenciaActual}`;
            }
            return "ORI - Reporte Comparativo";
        },
        tituloTablaConsolidado() {
            if (this.selVigencia) {
                return `Reporte ORI Consolidado ${this.selVigencia}`;
            }
            return "ORI - Reporte Consolidado";
        },
    },

    methods: {
        obtenerNombreColumnaSaldo(col) {
            const nombreBase = this.empresasConsolidadoNombres[col] || col.toUpperCase();
            return nombreBase;
        },
        obtenerNombreColumnaDiffCambio(col) {
            const nombreBase = this.empresasConsolidadoNombresDiff[col] || col.toUpperCase();
            return nombreBase;
        },
        getNombreMonedaConsolidado(tipo = 'funcional1') {
            const funcionalEsperada = tipo === 'funcional2' ? 2 : 1
            const moneda = (this.currency || []).find((item) => Number(item.isFuncional) === funcionalEsperada)
            if (!moneda) return ''
            return moneda.nombre || moneda.acronimo || ''
        },
        getMonedaConsolidadoParametro() {
            return this.monedaConsolidadoSeleccion === 'funcional2' ? 2 : 1
        },
        normalizaSelectorMonedaConsolidado() {
            const opciones = this.monedaConsolidadoOptions.map((item) => item.value)
            if (opciones.length === 0) {
                this.monedaConsolidadoSeleccion = 'funcional1'
                return
            }
            if (!opciones.includes(this.monedaConsolidadoSeleccion)) {
                this.monedaConsolidadoSeleccion = opciones[0]
            }
        },
        async loadButtonControlsFromDb() {
            const defaultControls = {
                Consolidado: true,
                Reporte: true,
                Informacion: true,
                AjusteConsol: true,
                AjusteCombinado: true,
                Empresas: true,
                SelectorMoneda: true,
                MonedaFuncional1: true,
                MonedaFuncional2: true
            }
            const controlMap = {
                300: "Consolidado",
                700: "Reporte",
                720: "Informacion",
                730: "AjusteConsol",
                740: "AjusteCombinado",
                750: "Empresas",
                600: "SelectorMoneda",
                610: "MonedaFuncional1",
                620: "MonedaFuncional2"
            }

            try {
                const roleId = Number(this.$store.state.userRole) || 0
                const response = await BotonesControl.getBotonesControl("REPORI", roleId)
                const botones = Array.isArray(response.data.botones) ? response.data.botones : []
                const controls = { ...defaultControls }

                botones.forEach((item) => {
                    const key = controlMap[Number(item.id_boton)]
                    if (!key) return
                    controls[key] = item.enabled !== false
                })

                this.$store.commit("setComponentControls", {
                    componentName: "ReporteORI",
                    controls
                })
            } catch (error) {
                console.log("Error cargando visibilidad de botones ORI:", error)
            } finally {
                if (!this.isConsolidadoVisible) {
                    this.mostrarConsolidado = false
                    this.mostrarEmpresas = false
                }
                this.normalizaSelectorMonedaConsolidado()
            }
        },
        onCambioMonedaConsolidado() {
            this.normalizaSelectorMonedaConsolidado()
        },
        getIndiceColumnaConsolidado(col = '') {
            const match = String(col || '').match(/(\d+)/)
            return match ? Number(match[1]) : 0
        },
        getValorColumnaConsolidado(item = {}, col = '') {
            const index = this.getIndiceColumnaConsolidado(col)
            if (!index) return 0
            const sufijo = this.monedaConsolidadoSeleccion === 'funcional2' ? '_m2' : ''
            const candidatos = [
                `prom${index}${sufijo}`,
                `sal${index}${sufijo}`,
                `fun${index}${sufijo}`,
                `c${index}${sufijo}`,
                `prom${index}`,
                `sal${index}`,
                `fun${index}`,
                `c${index}`
            ]
            for (const campo of candidatos) {
                if (item[campo] !== undefined && item[campo] !== null) {
                    return parseFloat(item[campo]) || 0
                }
            }
            return 0
        },
        getDiffCambioConsolidado(item = {}, col = '') {
            const index = this.getIndiceColumnaConsolidado(col)
            if (!index) return 0
            
            const sufijo = this.monedaConsolidadoSeleccion === 'funcional2' ? '_m2' : ''
            
            // Obtener prom (valor de referencia)
            let promValue = 0
            const promCandidatos = [`prom${index}${sufijo}`, `prom${index}`]
            for (const campo of promCandidatos) {
                if (item[campo] !== undefined && item[campo] !== null) {
                    promValue = parseFloat(item[campo]) || 0
                    break
                }
            }
            
            // Obtener cie (valor de comparación)
            let cieValue = 0
            const cieCandidatos = [`cie${index}${sufijo}`, `cie${index}`]
            for (const campo of cieCandidatos) {
                if (item[campo] !== undefined && item[campo] !== null) {
                    cieValue = parseFloat(item[campo]) || 0
                    break
                }
            }
            
            // Diff Cambio = cie - prom (según lo solicitado)
            return cieValue - promValue
        },
        // NUEVO MÉTODO: Suma todas las diferencias de cambio de las empresas
        getTotalDiffCambioConsolidado(item = {}) {
            if (!item) return 0
            let totalDiff = 0
            const sufijo = this.monedaConsolidadoSeleccion === 'funcional2' ? '_m2' : ''
            
            for (let i = 1; i <= this.columnasConsolidado.length; i++) {
                // Obtener cie (valor de comparación)
                let cieValue = 0
                const cieCandidatos = [`cie${i}${sufijo}`, `cie${i}`]
                for (const campo of cieCandidatos) {
                    if (item[campo] !== undefined && item[campo] !== null) {
                        cieValue = parseFloat(item[campo]) || 0
                        break
                    }
                }
                
                // Obtener prom (valor de referencia)
                let promValue = 0
                const promCandidatos = [`prom${i}${sufijo}`, `prom${i}`]
                for (const campo of promCandidatos) {
                    if (item[campo] !== undefined && item[campo] !== null) {
                        promValue = parseFloat(item[campo]) || 0
                        break
                    }
                }
                
                // Sumar la diferencia (cie - prom)
                totalDiff += (cieValue - promValue)
            }
            return totalDiff
        },
        getValorConsolidadoResumen(item = {}, tipo = 'total_consolidado') {
            const sufijo = this.monedaConsolidadoSeleccion === 'funcional2' ? '_m2' : ''
            const mapa = {
                ajustes: [`ajustes_prom${sufijo}`, `ajustes${sufijo}`, 'ajustes'],
                total_consolidado: [`total_consolidado_prom${sufijo}`, `total_consolidado${sufijo}`, 'total_consolidado', `total_prom${sufijo}`, `total${sufijo}`, 'total'],
                combinado: [`combinado_prom${sufijo}`, `combinado${sufijo}`, 'combinado'],
                total_combinado: [`total_combinado_prom${sufijo}`, `total_combinado${sufijo}`, 'total_combinado']
            }
            const candidatos = mapa[tipo] || [tipo]
            for (const campo of candidatos) {
                if (item[campo] !== undefined && item[campo] !== null) {
                    return parseFloat(item[campo]) || 0
                }
            }
            return 0
        },
        limpiarVistaManual() {
            this.listFilasManuales = [];
            this.listFilasAjustesConsol = [];
            this.datosConsultados = false;
            this.cerrarModalValor();
        },

        formatCurrency(value) {
            if (value === null || value === undefined) return '0';
            return new Intl.NumberFormat('es-CO', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }).format(value).replace(/\./g, ',');
        },

        async consultarDatos() {
            if (!this.selReporte || !this.selVigencia) {
                this.$toast.warning("Seleccione reporte y vigencia");
                return;
            }

            // Validación para Consolidado
            if (this.mostrarConsolidado) {
                if (this.mostrarEmpresas) {
                    if (!this.empresasSeleccionadas || this.empresasSeleccionadas.length === 0) {
                        this.$toast.warning("Seleccione al menos una empresa para consolidar");
                        return;
                    }
                } else if (!this.companyId) {
                    this.$toast.warning("No tiene seleccionada compañía");
                    return;
                }
            } else {
                if (!this.companyId) {
                    this.$toast.warning("Seleccione una compañía");
                    return;
                }
            }

            if (!this.mostrarBalance && !this.mostrarReporte && !this.mostrarInformacion && !this.mostrarAjusteConsol && !this.mostrarAjusteCombinado && !this.mostrarConsolidado) {
                this.$toast.warning("Seleccione al menos una opción (Balance, Reporte, Información, Ajuste Consol, Ajuste Combinado o Consolidado)");
                return;
            }

            this.isLoading = true;
            this.datosConsultados = true;

            try {
                this.listReportesGuardados = [];
                this.listReportesComparativo = [];
                this.listFilasManuales = [];
                this.listFilasAjusteConsol = [];
                this.listConsolidado = [];

                if (this.mostrarConsolidado) {
                    const empresasParaConsolidar = this.mostrarEmpresas
                        ? [...this.empresasSeleccionadas]
                        : [this.companyId];

                    await this.cargarConsolidado(empresasParaConsolidar);
                    this.mostrarEmpresas = false;
                    this.selectAllCompanies = false;
                    this.empresasSeleccionadas = [];

                    if (this.listConsolidado.length === 0) {
                        this.$toast.warning("No existe información consolidada para las empresas seleccionadas");
                    } else {
                        this.$toast.success("Reporte consolidado cargado correctamente");
                    }
                } else {
                    if (this.mostrarBalance) {
                        await this.cargarBalance();
                    }

                    if (this.mostrarReporte) {
                        await this.cargarReporteComparativo();
                    }

                    if (this.mostrarInformacion || this.mostrarAjusteConsol || this.mostrarAjusteCombinado) {
                        await this.cargarFilasManuales();
                    }

                    if (this.mostrarBalance && this.mostrarReporte && this.mostrarInformacion && this.mostrarAjusteConsol) {
                        this.$toast.success("Balance, Reporte e Información cargados");
                    } else if (this.mostrarBalance && this.mostrarReporte) {
                        this.$toast.success("Balance y Reporte cargados");
                    } else if (this.mostrarBalance && this.mostrarInformacion) {
                        this.$toast.success("Balance e Información cargados");
                    } else if (this.mostrarBalance && this.mostrarAjusteConsol) {
                        this.$toast.success("Balance y Ajustes Consol cargados");
                    } else if (this.mostrarReporte && this.mostrarInformacion) {
                        this.$toast.success("Reporte e Información cargados");
                    } else if (this.mostrarReporte && this.mostrarAjusteConsol) {
                        this.$toast.success("Reporte y Ajustes Consol cargados");
                    } else if (this.mostrarBalance) {
                        if (this.listReportesGuardados.length === 0 || !this.tieneDatosValidos()) {
                            this.$toast.warning("No existe información de Balance para esta compañía");
                        } else {
                            this.$toast.success("Balance cargado correctamente");
                        }
                    } else if (this.mostrarReporte) {
                        if (this.listReportesComparativo.length === 0) {
                            this.$toast.warning("No existe información de Reporte para esta compañía");
                        } else {
                            this.$toast.success("Reporte cargado correctamente");
                        }
                    } else if (this.mostrarInformacion) {
                        if (this.listFilasManuales.length === 0) {
                            this.$toast.warning("No existen filas de tipo Manual para esta configuración");
                        } else {
                            this.$toast.success("Información manual cargada correctamente");
                        }
                    } else if (this.mostrarAjusteConsol) {
                        if (this.listFilasManuales.length === 0) {
                            this.$toast.warning("No existen filas de tipo Ajuste de Consolidacion para esta configuración");
                        } else {
                            this.$toast.success("Ajustes de Consolidacion cargada correctamente");
                        }
                    } else if (this.mostrarAjusteCombinado) {
                        if (this.listFilasManuales.length === 0) {
                            this.$toast.warning("No existen filas de tipo Ajuste Combinado para esta configuración");
                        } else {
                            this.$toast.success("Ajuste Combinado cargado correctamente");
                        }
                    }
                }

            } catch (error) {
                console.error("Error cargando datos:", error);
                this.$toast.error("Error al cargar los datos");
                if (this.mostrarConsolidado) {
                    this.mostrarEmpresas = false;
                    this.selectAllCompanies = false;
                }
            } finally {
                this.isLoading = false;
            }
        },

        async exportarExcelConsolidado() {
            if (!this.listConsolidado.length) return;

            this.isLoading = true;
            try {
                const workbook = new XLSX.Workbook();
                const worksheet = workbook.addWorksheet("Reporte ORI Consolidado");

                const styles = {
                    tituloPrincipal: {
                        font: { name: "Calibri", size: 16, bold: true },
                        alignment: { horizontal: "center", vertical: "middle" },
                        border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
                    },
                    subtitulo: {
                        font: { name: "Calibri", size: 11, bold: true },
                        alignment: { horizontal: "center", vertical: "middle" },
                        border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
                    },
                    encabezado: {
                        font: { name: "Calibri", size: 11, bold: true, color: { argb: "000000" } },
                        alignment: { horizontal: "center", vertical: "middle" },
                        fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } },
                        border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
                    },
                    datoNormal: {
                        font: { name: "Calibri", size: 10 },
                        alignment: { horizontal: "left", vertical: "middle" },
                        border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
                    },
                    datoNumero: {
                        font: { name: "Calibri", size: 10 },
                        alignment: { horizontal: "right", vertical: "middle" },
                        border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
                    }
                };

                const userName = this.$store?.state?.userName || localStorage.getItem('userName') || 'Usuario';
                const reporteNombre = this.listReporte.find(r => r.codigo == this.selReporte)?.nombre || 'Reporte ORI';
                const totalColumnas = 1 + (this.columnasConsolidado.length * 2) + 3 + (this.vistaConsolidado === "Combinado" ? 2 : 0);
                const getExcelColumnName = (columnNumber) => {
                    let dividend = columnNumber;
                    let columnName = "";
                    while (dividend > 0) {
                        const modulo = (dividend - 1) % 26;
                        columnName = String.fromCharCode(65 + modulo) + columnName;
                        dividend = Math.floor((dividend - modulo) / 26);
                    }
                    return columnName;
                };
                const ultimaColumna = getExcelColumnName(totalColumnas);

                // Título principal
                worksheet.mergeCells(`A1:${ultimaColumna}1`);
                worksheet.getCell('A1').value = "ESTADOS DE OTROS RESULTADOS INTEGRALES - ORI";
                Object.assign(worksheet.getCell('A1'), styles.tituloPrincipal);

                // Fila 2: Vigencia
                worksheet.mergeCells(`A2:${ultimaColumna}2`);
                worksheet.getCell('A2').value = `Vigencia: ${this.selVigencia} | Consolidado de múltiples empresas`;
                Object.assign(worksheet.getCell('A2'), styles.subtitulo);

                // Fila 3: Generado por y Reporte
                worksheet.mergeCells(`A3:${ultimaColumna}3`);
                const today = new Date();
                const fechaFormateada = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
                worksheet.getCell('A3').value = `Generado: ${fechaFormateada} por ${userName} | Reporte: ${reporteNombre}`;
                Object.assign(worksheet.getCell('A3'), styles.subtitulo);

                worksheet.addRow([]);

                // Construir encabezados dinámicamente
                const headers = ['Descripción / NIIF (IFRS)'];

                this.columnasConsolidado.forEach(col => {
                    headers.push(this.obtenerNombreColumnaSaldo(col));
                    headers.push(this.obtenerNombreColumnaDiffCambio(col));
                });

                // Agregar columnas fijas
                headers.push('Ajustes', 'Consolidado', 'Consolidado Diferencia Cambio');
                if (this.vistaConsolidado === "Combinado") {
                    headers.push('Combinado', 'Total Combinado');
                }

                const headerRow = worksheet.addRow(headers);
                headerRow.eachCell((cell) => {
                    Object.assign(cell, styles.encabezado);
                });

                // Configurar ancho de columnas
                const columnWidths = [50];


                for (let i = 0; i < this.columnasConsolidado.length; i++) {
                    columnWidths.push(25, 25);
                }

                // Agregar ancho para columnas fijas
                columnWidths.push(25, 25, 25);
                if (this.vistaConsolidado === "Combinado") {
                    columnWidths.push(25, 25);
                }

                worksheet.columns = columnWidths.map(width => ({ width }));

                // Agregar datos
                this.listConsolidado.forEach(item => {
                    const rowData = [item.descripcion || '-'];

                    // Agregar valores de empresas (Saldo + Diff Cambio)
                    this.columnasConsolidado.forEach(col => {
                        rowData.push(this.getValorColumnaConsolidado(item, col) || 0);
                        rowData.push(this.getDiffCambioConsolidado(item, col) || 0);
                    });

                    // Agregar valores fijos
                    rowData.push(this.getValorConsolidadoResumen(item, 'ajustes') || 0);
                    rowData.push(this.getValorConsolidadoResumen(item, 'total_consolidado') || 0);
                    rowData.push(this.getTotalDiffCambioConsolidado(item) || 0);
                    if (this.vistaConsolidado === "Combinado") {
                        rowData.push(this.getValorConsolidadoResumen(item, 'combinado') || 0);
                        rowData.push(this.getValorConsolidadoResumen(item, 'total_combinado') || 0);
                    }

                    const row = worksheet.addRow(rowData);

                    // Aplicar estilos
                    row.getCell(1).style = styles.datoNormal;
                    for (let i = 2; i <= rowData.length; i++) {
                        row.getCell(i).style = styles.datoNumero;
                    }
                });

                worksheet.views = [{ state: 'frozen', ySplit: 5 }];

                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const link = document.createElement('a');
                const url = URL.createObjectURL(blob);
                link.href = url;

                link.download = `ORI_Consolidado_${this.selVigencia}.xlsx`;

                link.click();
                URL.revokeObjectURL(url);

                this.$toast.success("Excel exportado correctamente");
            } catch (error) {
                console.error("Error exportando:", error);
                this.$toast.error("Error al exportar Excel");
            } finally {
                this.isLoading = false;
            }
        },

        async cargarBalance() {
            try {
                const response = await Balance.obtenerFilasPrincipalesOri(
                    this.selReporte,
                    this.companyId,
                    this.selVigencia
                );

                let datos = response.data.data || [];

                // TRANSFORMAR los datos anidados
                if (datos.length > 0 && typeof datos[0] === 'object' && !Array.isArray(datos[0])) {
                    const primerElemento = datos[0];
                    const valores = Object.values(primerElemento);
                    datos = valores.filter(item => item && item.id);
                }

                // Si no hay datos, intentar copiar desde vigencia anterior
                if (datos.length === 0) {
                    const añoActual = parseInt(this.selVigencia.substring(0, 4));
                    const mes = this.selVigencia.substring(4, 6);
                    const vigenciaAnterior = `${añoActual - 1}${mes}`;

                    const userId = this.$store?.state?.userId || localStorage.getItem('userId');

                    await Balance.copiarConfiguracionOri(
                        this.selReporte,
                        this.companyId,
                        vigenciaAnterior,
                        this.selVigencia,
                        userId
                    );

                    // Volver a consultar después de copiar
                    const newResponse = await Balance.obtenerFilasPrincipalesOri(
                        this.selReporte,
                        this.companyId,
                        this.selVigencia
                    );

                    datos = newResponse.data.data || [];

                    if (datos.length > 0 && typeof datos[0] === 'object' && !Array.isArray(datos[0])) {
                        const primerElemento = datos[0];
                        const valores = Object.values(primerElemento);
                        datos = valores.filter(item => item && item.id);
                    }
                }

                if (datos.length === 0) {
                    this.listReportesGuardados = [];
                    return;
                }

                this.listReportesGuardados = datos.map(fila => ({
                    id: fila.id,
                    orden: fila.orden,
                    descripcion: fila.descripcion,
                    saldo_local: fila.total,
                    saldo_funcional: fila.total,
                    saldo_interna: fila.total
                }));

            } catch (error) {
                console.error("Error cargando Balance:", error);
                throw error;
            }
        },

        async cargarReporteComparativo() {
            try {
                const response = await Balance.obtenerReporteComparativoOri(
                    this.selReporte,
                    this.companyId,
                    this.selVigencia
                );

                if (response.data && response.data.data) {
                    // Usar los valores directamente sin modificar
                    this.listReportesComparativo = response.data.data;

                    if (response.data.vigencias) {
                        this.vigenciaActual = response.data.vigencias.actual;
                        this.vigenciaAnterior = response.data.vigencias.anterior;
                    }
                } else {
                    this.listReportesComparativo = [];
                }

            } catch (error) {
                console.error("Error cargando reporte comparativo:", error);
                this.listReportesComparativo = [];
                throw error;
            }
        },

        async cargarFilasManuales() {
            try {
                const formulacionObjetivo = this.mostrarAjusteCombinado ? 'mc' : (this.mostrarAjusteConsol ? 'ac' : 'm');
                const response = await Balance.obtenerFilasPrincipalesOri(
                    this.selReporte,
                    this.companyId,
                    this.selVigencia
                );

                let filas = response.data.data || [];

                if (filas.length > 0 && typeof filas[0] === 'object' && !Array.isArray(filas[0])) {
                    const primerElemento = filas[0];
                    const valores = Object.values(primerElemento);
                    filas = valores.filter(item => item && item.id);
                }

                // Si no hay datos, intentar copiar desde vigencia anterior
                if (filas.length === 0) {
                    const añoActual = parseInt(this.selVigencia.substring(0, 4));
                    const mes = this.selVigencia.substring(4, 6);
                    const vigenciaAnterior = `${añoActual - 1}${mes}`;

                    const userId = this.$store?.state?.userId || localStorage.getItem('userId');

                    await Balance.copiarConfiguracionOri(
                        this.selReporte,
                        this.companyId,
                        vigenciaAnterior,
                        this.selVigencia,
                        userId
                    );

                    // Volver a consultar después de copiar
                    const newResponse = await Balance.obtenerFilasPrincipalesOri(
                        this.selReporte,
                        this.companyId,
                        this.selVigencia
                    );

                    filas = newResponse.data.data || [];

                    if (filas.length > 0 && typeof filas[0] === 'object' && !Array.isArray(filas[0])) {
                        const primerElemento = filas[0];
                        const valores = Object.values(primerElemento);
                        filas = valores.filter(item => item && item.id);
                    }
                }

                if (filas.length === 0) {
                    this.listFilasManuales = [];
                    return;
                }

                const filasConFormulaciones = await Promise.all(
                    filas.map(async (filaItem) => {
                        const formulacionesResponse = this.mostrarAjusteConsol
                            ? await Balance.obtenerFormulacionesOriConsol(
                                this.selReporte,
                                this.companyId,
                                this.selVigencia,
                                filaItem.orden
                            )
                            : this.mostrarAjusteCombinado
                                ? await Balance.obtenerFormulacionesOriCombinado(
                                    this.selReporte,
                                    this.companyId,
                                    this.selVigencia,
                                    filaItem.orden
                                )
                                : await Balance.obtenerFormulacionesOri(
                                    this.selReporte,
                                    this.companyId,
                                    this.selVigencia,
                                    filaItem.orden
                                );

                        const formulaciones = formulacionesResponse.data.data || [];

                        console.log(`Formulaciones para orden ${filaItem.orden}:`, formulaciones);

                        const formulacionManual = formulaciones.find(
                            f => (f.formulacion || '').toString().trim().toLowerCase() === formulacionObjetivo
                        );

                        if (formulacionManual) {
                            console.log(`Formulación manual encontrada:`, formulacionManual);
                            console.log(`Valor guardado: ${formulacionManual.valor}`);

                            return {
                                id: filaItem.id,
                                orden: filaItem.orden,
                                descripcion: filaItem.descripcion,
                                formulaciones: formulaciones,
                                formulacionId: formulacionManual.id,
                                valorGuardado: formulacionManual.valor !== null ? parseFloat(formulacionManual.valor) : 0,
                                funcional1Guardado: formulacionManual.funcional1 !== null ? parseFloat(formulacionManual.funcional1) : 0
                            };
                        }

                        return null;
                    })
                );

                this.listFilasManuales = filasConFormulaciones.filter(filaItem => filaItem !== null);

                console.log('Filas manuales cargadas:', this.listFilasManuales);

            } catch (error) {
                console.error("Error cargando filas manuales:", error);
                this.listFilasManuales = [];
                throw error;
            }
        },

        abrirModalValor(fila) {
            if (this.isVigenciaBloqueada) {
                this.$toast.error("La vigencia seleccionada está deshabilitada para edición.");
                return;
            }
            this.filaSeleccionada = fila;
            this.valorIngresado = fila.valorGuardado !== null ? fila.valorGuardado : null;
            this.funcional1Ingresado = fila.funcional1Guardado !== null ? fila.funcional1Guardado : null;
            this.showModalValor = true;
        },

        cerrarModalValor() {
            this.showModalValor = false;
            this.filaSeleccionada = null;
            this.valorIngresado = null;
            this.funcional1Ingresado = null;
        },

        async guardarValorManual() {
            if (this.isVigenciaBloqueada) {
                this.$toast.error("La vigencia seleccionada está deshabilitada para edición.");
                return;
            }
            if (!this.filaSeleccionada || this.filaSeleccionada.orden === undefined || this.filaSeleccionada.orden === null) {
                this.$toast.error("No hay una fila válida seleccionada para guardar.");
                return;
            }
            if (this.valorIngresado === null || this.valorIngresado === '') {
                this.$toast.warning("Ingrese un valor válido");
                return;
            }
            if (this.funcional1Ingresado === null || this.funcional1Ingresado === '') {
                this.$toast.warning("Ingrese un valor funcional válido");
                return;
            }

            const userId = this.$store?.state?.userId || localStorage.getItem('userId');

            if (!userId) {
                this.$toast.error("No se encontró el ID de usuario");
                return;
            }

            this.isLoading = true;

            try {
                const formulacionObjetivo = this.mostrarAjusteCombinado ? 'mc' : (this.mostrarAjusteConsol ? 'ac' : 'm');

                if (!this.filaSeleccionada.formulacionId) {
                    this.$toast.warning("La formulación no está parametrizada para esta fila.");
                    return;
                }

                const payload = {
                    accion: 'UPDATE_FORMULACION',
                    id: this.filaSeleccionada.formulacionId || null,
                    codReporte: parseInt(this.selReporte, 10),
                    vigencia: this.selVigencia,
                    id_compania: parseInt(this.companyId, 10),
                    orden: parseInt(this.filaSeleccionada.orden, 10),
                    reporte: 'ORI',
                    niif: null,
                    cuentas: null,
                    contable: 0,
                    actual: 1,
                    operacion: '+',
                    formulacion: formulacionObjetivo,
                    valor: parseFloat(this.valorIngresado),
                    funcional1: parseFloat(this.funcional1Ingresado),
                    esConsol: this.mostrarAjusteConsol === true,
                    esCombinado: this.mostrarAjusteCombinado === true,
                    guardar_valor_manual: true,
                    u_crea: parseInt(userId, 10),
                    u_modifica: parseInt(userId, 10)
                };

                await Balance.gestionarFormulacionesOri(payload);

                this.filaSeleccionada.valorGuardado = parseFloat(this.valorIngresado);
                this.filaSeleccionada.funcional1Guardado = parseFloat(this.funcional1Ingresado);
                this.filaSeleccionada.formulacionId = this.filaSeleccionada.formulacionId || (payload.id);

                this.$toast.success("Valor guardado correctamente");
                this.cerrarModalValor();

            } catch (error) {
                console.error("Error guardando valor:", error);
                this.$toast.error(error.response?.data?.message || "Error al guardar el valor");
            } finally {
                this.isLoading = false;
            }
        },

        tieneDatosValidos() {
            if (!this.listReportesGuardados || this.listReportesGuardados.length === 0) {
                return false;
            }

            return this.listReportesGuardados.some(item => {
                return (item.saldo_local && item.saldo_local !== 0) ||
                    (item.saldo_funcional && item.saldo_funcional !== 0) ||
                    (item.saldo_interna && item.saldo_interna !== 0) ||
                    (item.descripcion && item.descripcion.trim() !== '');
            });
        },

        tieneAlgunDatoValido() {
            if (this.mostrarBalance) {
                if (this.listReportesGuardados.length > 0 && this.tieneDatosValidos()) {
                    return true;
                }
            }

            if (this.mostrarReporte) {
                if (this.listReportesComparativo.length > 0) {
                    return true;
                }
            }

            if (this.mostrarAjusteConsol || this.mostrarAjusteCombinado) {
                if (this.listFilasManuales.length > 0) {
                    return true;
                }
            }

            if (this.mostrarInformacion) {
                if (this.listFilasManuales.length > 0) {
                    return true;
                }
            }

            if (this.mostrarConsolidado) {
                if (this.listConsolidado.length > 0) {
                    return true;
                }
            }

            return false;
        },

        f_filterCompany() {
            if (this.grupoId) {
                const grupoIdNum = this.grupoId.toString();
                this.filteredCompany = this.listCompany.filter(company => {
                    if (!company.id_grupos) return false;
                    const gruposCompania = company.id_grupos.split(',').map(id => id.trim());
                    return gruposCompania.includes(grupoIdNum);
                });
            } else {
                this.filteredCompany = this.listCompany;
            }
            this.companyId = "";
        },

        handleConsolidadoChange(checked) {
            const isChecked = typeof checked === "boolean"
                ? checked
                : !!checked?.target?.checked;

            if (isChecked) {
                this.vistaConsolidado = "Normal";
                this.filtrarEmpresasPorGrupo();
            } else {
                this.empresasSeleccionadas = [];
                this.mostrarEmpresas = false;
                this.selectAllCompanies = false;
            }
        },

        handleEmpresasChange(checked) {
            const isChecked = typeof checked === "boolean"
                ? checked
                : !!checked?.target?.checked;

            if (isChecked) {
                this.filtrarEmpresasPorGrupo();
            } else {
                this.empresasSeleccionadas = [];
                this.selectAllCompanies = false;
            }
        },

        filtrarEmpresasPorGrupo() {
            if (this.mostrarConsolidado) {
                if (this.grupoId && this.grupoId !== 'todos' && this.grupoId !== '') {
                    const grupoIdNum = this.grupoId.toString();
                    this.listEmpresasDisponibles = this.listCompany.filter(company => {
                        if (!company.id_grupos) return false;
                        const gruposCompania = company.id_grupos.split(',').map(id => id.trim());
                        return gruposCompania.includes(grupoIdNum);
                    });
                } else {
                    this.listEmpresasDisponibles = [...this.listCompany];
                }
                this.empresasSeleccionadas = [];
                this.selectAllCompanies = false;
            }
        },

        seleccionarTodasEmpresas() {
            this.empresasSeleccionadas = this.listEmpresasDisponibles.map(c => c.id);
        },

        async cargarConsolidado(empresasIds = []) {
            try {
                const empresasStr = empresasIds.join(',');

                const response = await Balance.obtenerReporteConsolidadoOri(
                    this.selReporte,
                    empresasStr,
                    this.selVigencia,
                    this.getMonedaConsolidadoParametro()
                );

                if (response.data && response.data.data) {
                    let datos = response.data.data;

                    if (datos && typeof datos === 'object' && !Array.isArray(datos)) {
                        const keys = Object.keys(datos);
                        if (keys.length > 0 && !isNaN(keys[0])) {
                            datos = Object.values(datos);
                        } else {
                            datos = [datos];
                        }
                    }

                    const primeraFila = datos[0] || {};
                    const indicesColumnas = new Set();
                    Object.keys(primeraFila).forEach((key) => {
                        const match = key.match(/^(?:c|sal|prom|fun|cie)(\d+)(?:_m2)?$/);
                        if (match) {
                            indicesColumnas.add(Number(match[1]));
                        }
                    });
                    const columnasEmpresa = Array.from(indicesColumnas)
                        .sort((a, b) => a - b)
                        .map((index) => `c${index}`);

                    const empresasNombres = {};
                    const empresasNombresDiff = {};
                    empresasIds.forEach((empId, idx) => {
                        const empresa = this.listCompany.find(c => c.id == empId);
                        if (empresa) {
                            const nombreBase = empresa.acronym || empresa.nombre;
                            // Para la columna de Saldo: "AVD Saldo"
                            empresasNombres[`c${idx + 1}`] = nombreBase + ' Saldo';
                            // Para la columna de Diferencia Cambio: "AVD Diferencia Cambio"
                            empresasNombresDiff[`c${idx + 1}`] = nombreBase + ' Diferencia Cambio';
                        }
                    });

                    this.columnasConsolidado = columnasEmpresa;
                    this.empresasConsolidadoNombres = empresasNombres;
                    this.empresasConsolidadoNombresDiff = empresasNombresDiff;

                    this.listConsolidado = datos.map(item => {
                        const filaTransformada = {
                            ...item,
                            id: item.orden,
                            orden: item.orden,
                            descripcion: item.descripcion,
                            ajustes: item.ajustes || 0,
                            total_consolidado: item.total_consolidado || 0,
                            combinado: item.combinado || 0,
                            total_combinado: item.total_combinado || 0
                        };

                        columnasEmpresa.forEach(col => {
                            if (filaTransformada[col] === undefined || filaTransformada[col] === null) {
                                filaTransformada[col] = 0;
                            }
                        });

                        return filaTransformada;
                    });

                    console.log('Columnas empresas:', columnasEmpresa);
                    console.log('Nombres Saldo:', empresasNombres);
                    console.log('Nombres Diff Cambio:', empresasNombresDiff);
                    console.log('List consolidado transformado:', this.listConsolidado);
                } else {
                    this.listConsolidado = [];
                    this.columnasConsolidado = [];
                    this.empresasConsolidadoNombres = {};
                    this.empresasConsolidadoNombresDiff = {};
                }
            } catch (error) {
                console.error("Error cargando consolidado:", error);
                this.listConsolidado = [];
                this.columnasConsolidado = [];
                this.empresasConsolidadoNombres = {};
                this.empresasConsolidadoNombresDiff = {};
                throw error;
            }
        },

        toggleAllCompanies() {
            if (this.selectAllCompanies) {
                this.empresasSeleccionadas = this.listEmpresasDisponibles.map(c => c.id);
            } else {
                this.empresasSeleccionadas = [];
            }
        },

        async exportarExcelReporte() {
            if (!this.listReportesComparativo.length) return;

            this.isLoading = true;
            try {
                const workbook = new XLSX.Workbook();
                const worksheet = workbook.addWorksheet("Reporte ORI");

                const styles = {
                    tituloPrincipal: {
                        font: { name: "Calibri", size: 16, bold: true },
                        alignment: { horizontal: "center", vertical: "middle" },
                        border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
                    },
                    subtitulo: {
                        font: { name: "Calibri", size: 11, bold: true },
                        alignment: { horizontal: "center", vertical: "middle" },
                        border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
                    },
                    encabezado: {
                        font: { name: "Calibri", size: 11, bold: true, color: { argb: "000000" } },
                        alignment: { horizontal: "center", vertical: "middle" },
                        fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } },
                        border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
                    },
                    datoNormal: {
                        font: { name: "Calibri", size: 10 },
                        alignment: { horizontal: "left", vertical: "middle" },
                        border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
                    },
                    datoNumero: {
                        font: { name: "Calibri", size: 10 },
                        alignment: { horizontal: "right", vertical: "middle" },
                        border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
                    }
                };

                const company = this.listCompany.find(c => c.id == this.companyId);
                const companyName = company ? company.nombre : this.companyId;
                const userName = this.$store?.state?.userName || localStorage.getItem('userName') || 'Usuario';
                const reporteNombre = this.listReporte.find(r => r.codigo == this.selReporte)?.nombre || 'Reporte ORI';

                // Título principal
                worksheet.mergeCells('A1:B1');
                worksheet.getCell('A1').value = "ESTADOS DE OTROS RESULTADOS INTEGRALES - ORI";
                Object.assign(worksheet.getCell('A1'), styles.tituloPrincipal);

                // Fila 2: Vigencia y Compañía
                worksheet.mergeCells('A2:B2');
                worksheet.getCell('A2').value = `Vigencia: ${this.vigenciaActual} | Compañía: ${companyName}`;
                Object.assign(worksheet.getCell('A2'), styles.subtitulo);

                // Fila 3: Generado por y Reporte
                worksheet.mergeCells('A3:B3');
                const today = new Date();
                const fechaFormateada = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
                worksheet.getCell('A3').value = `Generado: ${fechaFormateada} por ${userName} | Reporte: ${reporteNombre}`;
                Object.assign(worksheet.getCell('A3'), styles.subtitulo);

                worksheet.addRow([]);

                const headers = ['Descripción / NIIF (IFRS)', `${this.vigenciaActual}`];
                const headerRow = worksheet.addRow(headers);
                headerRow.eachCell((cell) => {
                    Object.assign(cell, styles.encabezado);
                });

                worksheet.columns = [
                    { width: 50 },
                    { width: 25 }
                ];

                this.listReportesComparativo.forEach(item => {
                    const row = worksheet.addRow([
                        item.descripcion || '-',
                        item.saldo_actual || 0
                    ]);
                    row.getCell(1).style = styles.datoNormal;
                    row.getCell(2).style = styles.datoNumero;
                });

                worksheet.views = [{ state: 'frozen', ySplit: 5 }];

                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const link = document.createElement('a');
                const url = URL.createObjectURL(blob);
                link.href = url;

                link.download = `ORI_${companyName}_${this.vigenciaActual}.xlsx`;

                link.click();
                URL.revokeObjectURL(url);

                this.$toast.success("Excel exportado correctamente");
            } catch (error) {
                console.error("Error exportando:", error);
                this.$toast.error("Error al exportar Excel");
            } finally {
                this.isLoading = false;
            }
        },

        async exportarExcel() {
            if (!this.listReportesGuardados.length) return;

            this.isLoading = true;
            try {
                const workbook = new XLSX.Workbook();
                const worksheet = workbook.addWorksheet("Reportes ORI");

                const styles = {
                    tituloPrincipal: {
                        font: { name: "Calibri", size: 16, bold: true },
                        alignment: { horizontal: "center", vertical: "middle" },
                        border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
                    },
                    subtitulo: {
                        font: { name: "Calibri", size: 11, bold: true },
                        alignment: { horizontal: "center", vertical: "middle" },
                        border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
                    },
                    encabezado: {
                        font: { name: "Calibri", size: 11, bold: true, color: { argb: "000000" } },
                        alignment: { horizontal: "center", vertical: "middle" },
                        fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } },
                        border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
                    },
                    datoNormal: {
                        font: { name: "Calibri", size: 10 },
                        alignment: { horizontal: "left", vertical: "middle" },
                        border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
                    },
                    datoNumero: {
                        font: { name: "Calibri", size: 10 },
                        alignment: { horizontal: "right", vertical: "middle" },
                        border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
                    }
                };

                const company = this.listCompany.find(c => c.id == this.companyId);
                const companyName = company ? company.nombre : this.companyId;
                const userName = this.$store?.state?.userName || localStorage.getItem('userName') || 'Usuario';
                const reporteNombre = this.listReporte.find(r => r.codigo == this.selReporte)?.nombre || 'Reporte ORI';

                // Título principal
                worksheet.mergeCells('A1:D1');
                worksheet.getCell('A1').value = this.tituloTabla;
                Object.assign(worksheet.getCell('A1'), styles.tituloPrincipal);

                // Fila 2: Vigencia y Compañía
                worksheet.mergeCells('A2:D2');
                worksheet.getCell('A2').value = `Vigencia: ${this.selVigencia} | Compañía: ${companyName}`;
                Object.assign(worksheet.getCell('A2'), styles.subtitulo);

                // Fila 3: Generado por y Reporte
                worksheet.mergeCells('A3:D3');
                const today = new Date();
                const fechaFormateada = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
                worksheet.getCell('A3').value = `Generado: ${fechaFormateada} por ${userName} | Reporte: ${reporteNombre}`;
                Object.assign(worksheet.getCell('A3'), styles.subtitulo);

                worksheet.addRow([]);

                const headers = ['Descripción / NIIF (IFRS)', 'Local', `Funcional`, `Interna`];
                const headerRow = worksheet.addRow(headers);
                headerRow.eachCell((cell) => {
                    Object.assign(cell, styles.encabezado);
                });

                worksheet.columns = [
                    { width: 50 },
                    { width: 20 },
                    { width: 20 },
                    { width: 20 }
                ];

                this.listReportesGuardados.forEach(item => {
                    const row = worksheet.addRow([
                        item.descripcion || '-',
                        item.saldo_local || 0,
                        item.saldo_funcional || 0,
                        item.saldo_interna || 0
                    ]);
                    row.getCell(1).style = styles.datoNormal;
                    row.getCell(2).style = styles.datoNumero;
                    row.getCell(3).style = styles.datoNumero;
                    row.getCell(4).style = styles.datoNumero;
                });

                worksheet.views = [{ state: 'frozen', ySplit: 5 }];

                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const link = document.createElement('a');
                const url = URL.createObjectURL(blob);
                link.href = url;

                link.download = `ORI_${companyName}_${this.selVigencia}.xlsx`;

                link.click();
                URL.revokeObjectURL(url);

                this.$toast.success("Excel exportado correctamente");
            } catch (error) {
                console.error("Error exportando:", error);
                this.$toast.error("Error al exportar Excel");
            } finally {
                this.isLoading = false;
            }
        },

        async loadUserCompanies() {
            try {
                const userResult = await Balance.leaCompaniaUsuario();
                const companiaUsuario = userResult.data.companiaUsuario;

                const companiesResult = await Company.getAllCompanies();
                const allCompanies = companiesResult.data.companies;

                const filteredCompanies = allCompanies.filter((company) => {
                    if (this.$store.state.userRole == 1) return true;
                    return companiaUsuario.find(
                        (userCompany) =>
                            userCompany.id_usuario == this.$store.state.userId &&
                            userCompany.id_compania == company.id
                    );
                });

                this.listCompany = filteredCompanies;
                this.filteredCompany = filteredCompanies;
            } catch (err) {
                console.error("Error loading companies:", err);
            }
        },

        async loadVigencias() {
            try {
                const result = await PlanCuentas.getVigenciaPlancuentas();
                this.listVigencia = result.data.getVigencia;
            } catch (err) {
                console.error("Error loading vigencias:", err);
            }
        },

        async loadReportTypes() {
            try {
                const res = await TipoReporte.getAllTipoReporte();
                this.listReporte = res.data.typeReport;
            } catch (err) {
                console.error("Error loading report types:", err);
            }
        },

        async loadGrupos() {
            try {
                const result = await Grupo.getAllGrupos();
                this.listGrupos = result.data.grupos;
            } catch (err) {
                console.error("Error loading grupos:", err);
            }
        }
    },

    mounted() {
        this.isLoading = true;
        this.loadButtonControlsFromDb();
        Promise.all([
            this.loadUserCompanies(),
            this.loadVigencias(),
            this.loadReportTypes(),
            this.loadGrupos(),
            Currency.getAllCurrency().then((result) => {
                this.currency = result.data.currency || [];
                this.normalizaSelectorMonedaConsolidado();
            }).catch(() => {})
        ]).finally(() => {
            this.isLoading = false;
        });
    }
}
</script>

<style scoped>
.balance-table {
    font-size: 14px;
}

.form-control {
    font-size: 0.9rem !important;
    padding: 0.25rem 0.5rem !important;
    height: auto !important;
}

.form-control-lg {
    font-size: 1.25rem !important;
    padding: 0.5rem 1rem !important;
    height: auto !important;
    line-height: 1.5 !important;
    border-radius: 0.3rem !important;
}

.fs-5 {
    font-size: 1.25rem !important;
}

.fs-4 {
    font-size: 1.5rem !important;
}

.w-auto {
    width: auto !important;
}

.px-3 {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
}

.mr-1 {
    margin-right: 0.25rem !important;
}

.balance-table>>>.md-table-head {
    padding: 12px 8px !important;
    background-color: #f8f9fa !important;
    color: #495057 !important;
    font-weight: 700 !important;
    border-bottom: 2px solid #dee2e6 !important;
    border-left: none !important;
    border-right: none !important;
}

.balance-table>>>.md-table-cell {
    padding: 10px 8px !important;
    min-width: auto !important;
    border-left: 1px solid #dee2e6 !important;
    border-right: 1px solid #dee2e6 !important;
    border-bottom: 1px solid #dee2e6 !important;
}

.balance-table>>>.md-table-cell:first-child {
    border-left: 1px solid #dee2e6 !important;
}

.balance-table>>>.md-table-cell:last-child {
    border-right: 1px solid #dee2e6 !important;
}

.balance-table>>>.md-table-row:first-child .md-table-cell {
    border-top: none !important;
}

.balance-table>>>.md-table {
    width: 100% !important;
    table-layout: fixed !important;
    border-collapse: collapse !important;
}

.balance-table>>>.md-table-row {
    border-bottom: 1px solid #dee2e6 !important;
}

.balance-table>>>.md-table-toolbar {
    min-height: 60px !important;
    padding: 12px 16px !important;
    background-color: #ffffff !important;
    border-bottom: 1px solid #dee2e6 !important;
}

.principal-table>>>.md-table-cell:nth-child(1) {
    width: 400px !important;
    max-width: 400px !important;
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: unset !important;
    word-wrap: break-word !important;
    line-height: 1.2 !important;
    height: auto !important;
    min-height: 40px !important;
}

.principal-table>>>.md-table-cell:nth-child(2),
.principal-table>>>.md-table-cell:nth-child(3),
.principal-table>>>.md-table-cell:nth-child(4) {
    width: 200px !important;
    max-width: 200px !important;
}

.descripcion-cell {
    text-align: left !important;
    white-space: normal !important;
    word-wrap: break-word !important;
}

.number-cell {
    text-align: right !important;
}

.loading-spinner {
    text-align: center;
}

.text-left {
    text-align: left !important;
}

.text-center {
    text-align: center !important;
}

.btn-ingresar-valor {
    min-width: 150px;
}

/* Estilos del modal */
.valor-dialog>>>.md-dialog {
    max-width: 500px;
    width: 90%;
}

.dialog-header-create {
    background: #2e507a;
    color: white;
    padding: 15px 20px;
}

.form-container {
    padding: 20px 0;
}

.form-group {
    margin-bottom: 20px;
}

.field-label {
    display: block;
    font-weight: 600;
    margin-bottom: 8px;
    color: #2c3e50;
}

.filtro-label {
    font-size: 1.5rem !important;
    font-weight: 700 !important;
}

.checkbox-label {
    font-weight: 400 !important;
}

.compact-toggle-container {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-right: 10px;
}

.toggle-label {
    font-size: 14px;
    font-weight: 600;
    color: #495057;
    min-width: 80px;
    text-align: right;
}

.compact-switch {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 20px;
}

.compact-switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.compact-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: .2s;
    border-radius: 20px;
}

.compact-slider:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    transition: .2s;
    border-radius: 50%;
}

.compact-switch input:checked+.compact-slider {
    background-color: #007bff;
}

.compact-switch input:checked+.compact-slider:before {
    transform: translateX(20px);
}

input[type="checkbox"] {
    transform: scale(1.1);
    margin-right: 0.25rem;
}

.field-label.required:after {
    content: '*';
    color: #cd2838;
    margin-left: 4px;
}

.principal-table>>>.md-table-row {
    cursor: pointer;
    transition: background-color 0.2s;
}

.principal-table>>>.md-table-row:hover {
    background-color: #f0f7ff;
}

.empresas-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.empresa-checkbox {
    min-width: 200px;
    background: #f8f9fa;
    padding: 8px 12px;
    border-radius: 6px;
    margin-right: 10px !important;
}

.empresa-checkbox:hover {
    background: #e9ecef;
}

.empresa-item {
    border-bottom: 1px solid #eee;
    cursor: pointer;
    transition: background-color 0.2s;
}

.empresa-item:hover {
    background-color: #f0f7ff;
}

.empresa-item label {
    width: 100%;
    cursor: pointer;
    margin: 0;
}
</style>
<style src="../main.css"></style>